// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const doNothing = () => ({});

const ConfirmationModal = t.struct({
    confirmMessage: t.String,
    isOpen: t.Boolean,
    onClose: t.Function,
    onConfirm: t.Function,
    title: t.String
}, 'ConfirmationModal');

export const getDefaultState = () => new ConfirmationModal({
    confirmMessage: '',
    isOpen: false,
    onClose: doNothing,
    onConfirm: doNothing,
    title: ''
});

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/tcsm/shared/state/confirmation-modal.js